import { useState } from 'react';
import { Link } from '@tanstack/react-router';
import { ArrowLeft, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { PlanEditor } from '@/components/commission/plan-editor';

export function CommissionPlansPage() {
  const [editorOpen, setEditorOpen] = useState(false);
  const [editingPlan, setEditingPlan] = useState<any>(null);

  // Placeholder - will be wired to trpc.commission.listPlans
  const plans: any[] = [];

  const handleEdit = (plan: any) => {
    setEditingPlan(plan);
    setEditorOpen(true);
  };

  const handleCreate = () => {
    setEditingPlan(null);
    setEditorOpen(true);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Link to="/commissions" className="text-muted-foreground hover:text-foreground">
            <ArrowLeft className="h-5 w-5" />
          </Link>
          <div>
            <h1 className="text-2xl font-bold tracking-tight">Commission Plans</h1>
            <p className="text-muted-foreground">Configure commission structures for your team.</p>
          </div>
        </div>
        <Dialog open={editorOpen} onOpenChange={setEditorOpen}>
          <DialogTrigger asChild>
            <Button onClick={handleCreate}>
              <Plus className="mr-2 h-4 w-4" />
              New plan
            </Button>
          </DialogTrigger>
          <DialogContent className="max-w-2xl">
            <DialogHeader>
              <DialogTitle>{editingPlan ? 'Edit Plan' : 'Create Plan'}</DialogTitle>
            </DialogHeader>
            <PlanEditor
              plan={editingPlan}
              onSave={() => setEditorOpen(false)}
              onCancel={() => setEditorOpen(false)}
            />
          </DialogContent>
        </Dialog>
      </div>

      {plans.length === 0 ? (
        <Card>
          <CardContent className="py-12 text-center text-muted-foreground">
            No commission plans configured yet. Create your first plan to get started.
          </CardContent>
        </Card>
      ) : (
        <div className="grid gap-4 md:grid-cols-2">
          {plans.map((plan) => (
            <Card key={plan.id} className="cursor-pointer hover:shadow-md transition-shadow"
                  onClick={() => handleEdit(plan)}>
              <CardHeader>
                <div className="flex items-center justify-between">
                  <CardTitle>{plan.name}</CardTitle>
                  <Badge variant="secondary">{plan.config.type}</Badge>
                </div>
                <CardDescription>{plan.description}</CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground">
                  {plan.assignmentCount ?? 0} team members assigned
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
